import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppLaunchDetection } from '@hooks/use-app-launch-detection';
import { getLastPathCookie } from '@utils/last-path-storage/get-last-path-cookie';

import { START_PATHNAME, UNRESTORED_PATHNAMES } from './constants';

/**
 * Restores the last visited path when the Xceed Pro webview launches on its start page.
 */
export const LastPathPersistence: React.FC = () => {
  const { isInitialLoad, resetInitialLoad } = useAppLaunchDetection();
  const location = useLocation();

  useLayoutEffect(() => {
    // The start page is seen here before it redirects to the venue picker. Any other page, the picker included, was
    // opened by a link, a reload or an impersonation, and restoring would replace it.
    if (isInitialLoad && location.pathname === START_PATHNAME) {
      // Add a small delay to ensure any pending localStorage operations are complete
      setTimeout(() => {
        // Get the last visited path from localStorage
        const lastPath = getLastPathCookie();

        // Reset the initial load state to prevent multiple redirects
        resetInitialLoad();

        // On the pathname, so a start page stored with a query is skipped too: a restore never reloads onto the
        // start page, so it cannot loop.
        if (lastPath && !UNRESTORED_PATHNAMES.has(lastPath.split('?')[0])) {
          // Use replace to completely bypass the router
          // This prevents any router redirects from happening
          globalThis.location.replace(lastPath);
        }
      }, 50); // Small delay to ensure localStorage operations are complete
    }
  }, [isInitialLoad, location.pathname, resetInitialLoad]);

  // This component doesn't render anything
  return null;
};
